import script from "./QualityIndicatorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./QualityIndicatorComponent.vue?vue&type=script&setup=true&lang=js"

import "./QualityIndicatorComponent.vue?vue&type=style&index=0&id=f3c0575a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c0575a"]])

export default __exports__